import { Box, List, Stack, Typography } from "@mui/material";
import type { AchievementResponse } from "@bw/shared/types/generated";
import { SectionHeader } from "../../../common/components/SectionHeader";
import { AchievementBadge } from "./AchievementBadge";

export function AchievementList({
  achievements,
  allTo,
}: {
  achievements: AchievementResponse[];
  /** Where "All" leads (the achievements page), when shown. */
  allTo?: string;
}) {
  return (
    <Box component="section" aria-labelledby="match-achievements-heading">
      <Stack spacing={1}>
        <SectionHeader
          id="match-achievements-heading"
          title="Achievements"
          action={allTo ? { label: "All", to: allTo, ariaLabel: "All achievements" } : undefined}
        />
        {achievements.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No match achievements yet.
          </Typography>
        ) : (
          <List disablePadding sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {achievements.map((achievement) => (
              <AchievementBadge key={achievement.achievement_id} achievement={achievement} />
            ))}
          </List>
        )}
      </Stack>
    </Box>
  );
}
